import React, { useState, useEffect } from 'react';
import { Overlay } from 'components';
import { mount } from './mount';

export const FormSuccessModal = mount('app-form-success-modal', props => {

  const [ overlay, setOverlay ] = useState();
  const [ content, setContent ] = useState();

  useEffect(() => {
    window.formOnSuccess = response => {
      setOverlay(true);
      setContent(response.data.actions.success_message);
    }
  }, []);

  return (
    <Overlay overlay={overlay} close={() => setOverlay(false)}>
      <div dangerouslySetInnerHTML={{__html: content }} />
    </Overlay>
  );
});

